import { createAsyncThunk } from '@reduxjs/toolkit';

import { getFeedbackSearchFeed } from '../../utils/api';

export const fetchFeedbackSearchFeed = createAsyncThunk(
  'feedbackSearchFeed/fetchFeedbackSearchFeed',
  () => getFeedbackSearchFeed(),
);
